import styled from "styled-components";

// import { device } from "src/styles/device";
// import { getLocale } from "react-i18nify";
import * as MatStyled from "@mui/material/styles";

import device from "src/styles/device";

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  position: relative;
  padding: 80px 120px;
  margin: auto;
  & > div > p {
    word-wrap: break-word;
  }

  @media ${device.tabletL} {
    padding: 16px 24px;
  }

  @media ${device.mobileL} {
    padding: 16px;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const TutorialVideo = ({ open }) => {
  return (
    <Main
      sx={{ width: "100%", marginTop: "75px", background: "#fff" }}
      open={open}
    >
      <Container>
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "1.5rem",
          }}
        >
          ขั้นตอนการลงสินค้า
        </p>
        <div
          style={{
            background: "#f7f7f7",
            display: "flex",
            justifyContent: "center",
            padding: "32px",
            borderRadius: "16px",
          }}
        >
          <video
            style={{ boxShadow: "0 0 8px -1px", maxWidth: "100%" }}
            autoPlay
            controls
            muted
            loop
            src="https://xsurface-images.s3.ap-southeast-1.amazonaws.com/%E0%B8%A7%E0%B8%B4%E0%B8%98%E0%B8%B5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A5%E0%B8%87%E0%B8%AA%E0%B8%B4%E0%B8%99%E0%B8%84%E0%B9%89%E0%B8%B2.mp4"
          />
        </div>
      </Container>
    </Main>
  );
};
export default TutorialVideo;
